// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"7dff8219","186":"fbd59b7e","406":"e5e4a5f2","747":"6aae69e0","880":"0c2faa1d","992":"987ce19b"}[chunkId] + ".chunk.css";
};